import { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

import { Toaster, toast } from "react-hot-toast";

// @mui material components
import Grid from "@mui/material/Grid";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiLabel from "components/VuiLabel";
import VuiInput from "components/VuiInput";
import VuiInputMask from "components/VuiInputMask";
import VuiInputButton from "components/VuiInputTextButton";
import VuiSelect from "components/VuiSelect";
import VuiButtonCustom from "components/VuiButtonCustom";
import VuiCheckBox from "components/VuiCheckBox";

import { ViuCircularProgress } from "components/VuiCircularWithValueLabel";

import Footer from "examples/Footer";

// Images
import Loading from "examples/Icons/Loading";

// Helper
import { validateCPF, validateEmail } from "helpers/utilities";

import useWindowDimensions from "hooks/useWindowDimensions";
import breakpoints from "assets/theme/base/breakpoints";

import colors from "assets/theme/base/colors";

import api, { backEndUrl, frontEndUrl, backImgUrl } from "services/api";

import { Container, Content, TextArea, FlexRow } from "./styles";

function Empty(value) {
  return !(value
    ? typeof value === "object"
      ? Array.isArray(value)
        ? !!value.length
        : !!Object.keys(value).length
      : true
    : false);
}

function VuiRow() {
  return <div style={{ height: 30 }}></div>;
}

function VuiContainer({ children }) {
  return <div style={{ marginTop: 10, width: "100%" }}>{children}</div>;
}

function LoadingServiceOrder() {
  const { height, width } = useWindowDimensions();
  return (
    <VuiBox>
      <Loading />
    </VuiBox>
  );
}

function FocusNextField(fieldName) {
  const nextfield = document.querySelector(`input[name=${fieldName}]`);
  nextfield.focus();
}

function IsCurrentBoss(office) {
  return (
    office.toUpperCase() === "GESTOR" ||
    office.toUpperCase() === "SUPERVISOR" ||
    office.toUpperCase() === "CHEFE"
  );
}

const notify = (message) =>
  toast.success(message, {
    style: {
      fontSize: 16,
      borderRadius: "5px",
      background: "#333",
      color: "#fff",
    },
  });

const initStates = {
  idOrderService: "",
  dtOrderService: moment().format("DD/MM/YYYY HH:mm"),
  registry: "",
  user: "",
  department: "",
  typeService: {},
  gender: {},
  id_individual_register: "",
  email: "",
  phone: "",
  branch: "",
  problemDescription: "",
  newUserAD: "",
  assignCallTo: [],
  checkNumberSei: false,
  numberSei: "",
};

const initNewUserActiveDirectory = {
  registration: "",
  fullName: "",
  id_individual_register: "",
  loginName: "",
  eMail: "",
  personaleMail: "",
  departmentAcronym: "",
  phone: "",
  branch: "",
  checkUserAccept: false,
};

const initTypeServiceSelect = {
  label: "",
  value: "",
  isBoss: false,
  placeholder: "",
};

function FormServiceOrder({ isMobile, onClose = () => {} }) {
  const idServiceOrder = uuidv4().split("-");
  const userLogged = JSON.parse(localStorage.getItem("user"));
  const [isDisabledText, setIsDisabledText] = useState(true);
  const [isDisabledInputs, setIsDisabledInputs] = useState(true);
  const [isDisabledSave, setIsDisabledSave] = useState(true);
  const [lstTypeService, setLstTypeService] = useState(null);
  const [typeServiceSelect, setTypeServiceSelect] = useState(initTypeServiceSelect);
  const [states, setStates] = useState({
    ...initStates,
    idOrderService: idServiceOrder[0] + "" + idServiceOrder[1] + "" + idServiceOrder[2],
  });
  const [isSuccessRegister, setIsSuccessRegister] = useState(false);
  const [isFinishProcess, isSetFinishProcess] = useState(false);

  const [lstGender, setLstGender] = useState([
    { label: "Masculino", value: "Masculino" },
    { label: "Feminino", value: "Feminino" },
  ]);
  const [indexGender, setIndexGender] = useState(null);
  const [lstAssignCallTo, setLstAssignCallTo] = useState([]);

  async function saveSupportCall() {
    const newOccurrence = {
      ...states,
      user: userLogged,
      typeService: { label: states.typeService.label, value: states.typeService.value },
      lstAssignCallTo: lstAssignCallTo,
    };

    // console.log(">>> newOccurrence:", newOccurrence);
    const res = await api.post(`occurrence/register`, newOccurrence, {
      headers: { "Content-Type": "application/json", authorization: userLogged.token },
    });

    if (res.data.data.client) {
      notify(res.data.data.message);
      setTimeout(() => {
        setIsSuccessRegister(true);
      }, 3000);
    }
  }

  async function searchRegister() {
    const value = states.registry;
    console.log(">>> states.registry:", value);

    if (value.length > 3) {
      let arrUserFound = { ...initStates };

      const res1 = await api.get(`users/?velti=${value}`);
      const dataUser = res1.data.data.length > 0 ? res1.data.data[0] : [];

      const res2 = await api.get(`velti/s?register=${value}`);
      const dataVelti = res2.data;

      // console.log(">>> users?velti ...............:", dataUser, typeof dataUser, dataUser.length);
      // console.log(">>> velti/s?register:dataVelti:", dataVelti);

      if (!dataVelti.found) {
        notify(`Matricula do colaborador VELTI não cadastrado...`);
        return null;
      }

      if (dataVelti.found) {
        // console.log(">>> dataUser: encontrado");
        // console.log(">>> dataVelti:", dataVelti);
        // console.log(">>> arrUserFound:", { ...dataVelti });
        // console.log(">>> lstDepartment:", { ...lstDepartment });
        arrUserFound = { ...dataVelti };
      }

      if (dataUser.gender === "") {
        const strGenderByName = dataVelti.name.split(" ")[0].slice(-1).toUpperCase();

        if (strGenderByName === "O") {
          dataUser.gender = "Masculino";
        } else if (strGenderByName === "A") {
          dataUser.gender = "Feminino";
        }
      }

      dataUser.branch = dataUser.branch ? dataUser.branch : "";

      setIndexGender(lstGender.findIndex((x) => x.value === dataUser.gender));

      setStates({ ...states, ...arrUserFound, ...dataUser, registry: value });
      setIsDisabledInputs(false);
      FocusNextField("id_individual_register");
    } else if (value.length === 0 || value === 0) {
      setStates(initStates);
    }
  }

  useEffect(() => {
    async function load() {
      const supports = await api.get(`types/supports`);
      const newLstTypeService = [];

      supports.data.data.map((i) => {
        newLstTypeService.push({
          label: i.name,
          value: i.value,
          isBoss: i.isBoss,
          caption: i.caption,
          placeholder: i.placeholder,
        });
      });

      setLstTypeService(newLstTypeService);

      if (newLstTypeService.length === 1) {
        setTypeServiceSelect(newLstTypeService[0]);
        setIsDisabledText(false);
      }
    }

    load();
  }, [false]);

  useEffect(() => {
    setIsDisabledSave(
      states.registry.length > 0 &&
        states.id_individual_register.length > 0 &&
        indexGender > -1 &&
        states.email.length > 0 &&
        states.phone.length > 0 &&
        states.branch.length > 0 &&
        states.problemDescription.length > 0
    );
  }, [states]);

  if (isFinishProcess) {
    return (
      <Container>
        <Content width={50}>
          <Grid container spacing={3} p={3}>
            <Grid item xs={12} lg={12} xl={12}>
              <VuiLabel title="Ticket criado com sucesso!" sizeTitle={42} />
              <VuiRow />
              <VuiLabel
                title="Seu ticket foi criado com sucesso, a partir deste momento o usuário poderá acompanhar o suporte pelo ID do Ticket."
                sizeTitle={24}
              />
              <VuiRow />
              <VuiLabel
                title="Ticket #: "
                sizeTitle={20}
                subtitle={states?.idOrderService}
                openLinkClick={`/occurrenceview?occurrence=${states?.idOrderService}`}
                sizeSubTitle={20}
              />
              <VuiLabel
                title="Data: "
                sizeTitle={20}
                subtitle={states?.dtOrderService}
                sizeSubTitle={20}
              />
              <VuiLabel title="Nome: " sizeTitle={20} subtitle={states?.name} sizeSubTitle={20} />
              <VuiLabel
                title="E-mail: "
                sizeTitle={20}
                subtitle={states?.email}
                sizeSubTitle={20}
              />
            </Grid>

            <Grid item xs={12} lg={6} xl={10}></Grid>

            <Grid item xs={12} lg={6} xl={10}></Grid>
            <Grid item xs={12} lg={6} xl={2}>
              <VuiButtonCustom
                title="Fechar"
                color="dark"
                onClick={() => {
                  // onAction(1);
                  const idServiceOrder = uuidv4().split("-");
                  setStates({
                    ...initStates,
                    idOrderService:
                      idServiceOrder[0] + "" + idServiceOrder[1] + "" + idServiceOrder[2],
                  });
                  setTypeServiceSelect(initTypeServiceSelect);
                  setIndexGender(null);
                  isSetFinishProcess(false);
                }}
              />
            </Grid>
          </Grid>
        </Content>
      </Container>
    );
  }

  if (isSuccessRegister) {
    return (
      <Container>
        <Content height={30} width={16}>
          <Grid container spacing={3} p={2}>
            <Grid item xs={12} lg={12} xl={12}>
              <ViuCircularProgress
                label={[
                  { min: 1, max: 79, value: 1, msg: "Aguarde... Salvando informações" },
                  { min: 80, max: 100, value: 100, msg: "Aguarde... Finalizando o processo" },
                ]}
                onExec={() => {
                  setIsSuccessRegister(false);
                }}
                onProgress={async (n) => {
                  {
                    if (n === 15) {
                      console.log(">>> Salvar informações aqui", n);
                      saveSupportCall();
                    }
                    if (n === 85) {
                      console.log(">>> Finalizando processo", n);
                    }
                    if (n >= 99) {
                      isSetFinishProcess(true);
                    }
                  }
                }}
              />
            </Grid>
          </Grid>
        </Content>
      </Container>
    );
  }

  return (
    <>
      <Content width={isMobile ? 90 : 60} p={isMobile ? 0.5 : 2.25}>
        <Grid container spacing={0}>
          <Grid item xs={12} lg={12} xl={12}>
            <VuiLabel title="Abertura de Chamado" sizeTitle={32} />
            <VuiRow />

            <Grid container spacing={1}>
              {/* Line 1 */}
              <Grid item xs={12} lg={12} xl={4}>
                <VuiLabel title="Operador do Chamado" />
                <VuiInput
                  placeholder="Informe a Contato/Responsável"
                  value={userLogged.name}
                  disabled
                />
              </Grid>

              <Grid item xs={12} lg={12} xl={4} />
              <Grid item xs={12} lg={12} xl={4} />

              {/* Line 2 */}
              <Grid item xs={12} lg={12} xl={4}>
                <VuiLabel title="Matricula do Requerente" />
                <VuiInputButton
                  name="registry"
                  placeholder={`Informe a matricula`}
                  value={states.registry}
                  type="tel"
                  onChange={async (e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    setStates({ ...states, registry: value });
                  }}
                  onKeyDown={async (e) => {
                    // Example: Detect Enter key press
                    if (e.key === "Enter") {
                      if (states.registry !== "") {
                        await searchRegister();
                      }
                    }
                  }}
                  onClickOk={async () => {
                    await searchRegister();
                  }}
                />
              </Grid>

              <Grid item xs={12} lg={12} xl={6}>
                <VuiLabel title="Nome do Requerente" />
                <VuiInput placeholder="Nome do requerente" value={states.name} disabled />
              </Grid>

              <Grid item xs={12} lg={12} xl={2}>
                <div style={{ width: isMobile ? "180%" : "100%" }}>
                  {!isDisabledInputs ? (
                    <VuiSelect
                      label="Sexo"
                      name="selectGender"
                      placeholder="Selecione..."
                      options={lstGender}
                      defaultValue={indexGender !== null ? lstGender[indexGender] : null}
                      onCustomChange={async (e) => {
                        setIndexGender(lstGender.findIndex((x) => x.value === e.value));
                        setStates({
                          ...states,
                          gender: e,
                        });
                      }}
                    />
                  ) : (
                    <>
                      <VuiLabel title="Sexo" />
                      <VuiInput placeholder="Selecione..." value={""} disabled />
                    </>
                  )}
                </div>
              </Grid>

              {/* Line 3 */}
              <Grid item xs={12} lg={12} xl={3}>
                <VuiLabel title="CPF" />
                <VuiInputMask
                  placeholder="Informe seu CPF"
                  mask="cpf"
                  name="id_individual_register"
                  value={states?.id_individual_register}
                  onChange={async (e) => {
                    const value = e.target.value;
                    const lengthValue = value.replace(/\_|\.|\-/g, "").length;
                    setStates({ ...states, id_individual_register: value });
                    if (lengthValue === 11) {
                      if (validateCPF(value.replace(/\_|\.|\-/g, ""))) {
                        FocusNextField("email");
                      } else {
                        notify(`Número de CPF "${value}" inválido`);
                      }
                    }
                  }}
                  onKeyDown={(e) => {
                    const value = states.id_individual_register;
                    if (e.key === "Enter") {
                      if (value.length === 14) {
                        if (validateCPF(value.replace(/\_|\.|\-/g, ""))) {
                          FocusNextField("email");
                        }
                      }
                    }
                  }}
                  disabled={isDisabledInputs}
                />
              </Grid>

              <Grid item xs={12} lg={12} xl={3}>
                <VuiLabel title="E-mail Pessoal" />
                <VuiInput
                  name="email"
                  placeholder="Informe o e-mail pessoal"
                  value={states.email}
                  onChange={async (e) => {
                    const value = e.target.value;
                    setStates({ ...states, email: value });
                    if (/^[\w-\.]+@([\w-]+\.)+[\w-]{4}$/g.test(value)) {
                      FocusNextField("phone");
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      FocusNextField("phone");
                    }
                  }}
                  disabled={isDisabledInputs}
                />
              </Grid>

              <Grid item xs={12} lg={12} xl={3}>
                <VuiLabel title="Celular" />
                <VuiInputMask
                  name="phone"
                  mask="phone"
                  placeholder="Informe o número do celular"
                  value={states?.phone}
                  onChange={(e) => {
                    const value = e.target.value;
                    setStates({ ...states, phone: value });
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      FocusNextField("branch");
                    }
                  }}
                  disabled={isDisabledInputs}
                />
              </Grid>

              <Grid item xs={12} lg={12} xl={3}>
                <VuiLabel title="Ramal" />
                <VuiInput
                  name="branch"
                  placeholder="Informe o Ramal"
                  value={states.branch}
                  onChange={(e) => {
                    const value = e.target.value;
                    setStates({ ...states, branch: value });
                  }}
                />
              </Grid>

              {/* Line 4 */}
              <Grid item xs={12} lg={12} xl={2}>
                <VuiLabel title="Processo iniciado no SEI?" />
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <VuiCheckBox
                    // label={`Processo Iniciado SEI`}
                    name="checkUserAccept"
                    value={states.checkNumberSei}
                    onChange={(e) => {
                      console.log(">>> checkUserAccept:", e.target.checked);
                      setStates({
                        ...states,
                        checkNumberSei: !states.checkNumberSei,
                      });
                    }}
                    disabled={isDisabledInputs}
                  />
                </div>
              </Grid>

              <Grid item xs={12} lg={12} xl={2}>
                <VuiLabel title="Número SEI" />
                <VuiInput
                  name="numberSei"
                  placeholder="Informe número do SEI"
                  value={states.numberSei}
                  onChange={(e) => {
                    const value = e.target.value;
                    setStates({ ...states, numberSei: value });
                  }}
                  disabled={!states.checkNumberSei}
                />
              </Grid>

              <Grid item xs={12} lg={12} xl={8}>
                <VuiLabel title="Departamento" />
                <VuiInput placeholder="Nome do departamento" value={states.department} disabled />
              </Grid>

              {/* Line 5 */}
              <Grid item xs={12} lg={12} xl={2}>
                <VuiLabel title="Número da Ordem" />
                <VuiInput
                  placeholder="ID da Ordem de Serviço"
                  value={isDisabledInputs ? "" : states.idOrderService}
                  disabled
                />
              </Grid>

              <Grid item xs={12} lg={12} xl={2}>
                <VuiLabel title="Data de Abertura" />
                <VuiInput
                  placeholder="Data e hora do chamado"
                  value={isDisabledInputs ? "" : states.dtOrderService}
                  disabled
                />
              </Grid>

              <Grid item xs={12} lg={12} xl={4}>
                <div style={{ width: isMobile ? "180%" : "100%" }}>
                  {lstTypeService && lstTypeService.length > 1 && !isDisabledInputs ? (
                    <VuiSelect
                      label="Tipo de Manutenção"
                      name="selectTypeMaintenance"
                      placeholder={
                        isMobile ? "Escolha a Manutenção" : "Informe o Tipo de Manutenção"
                      }
                      options={lstTypeService}
                      defaultValue={null}
                      onCustomChange={async (e) => {
                        // console.log(">>> lstTypeService:", e);
                        setTypeServiceSelect(e);
                        setIsDisabledText(false);
                        setStates({
                          ...states,
                          typeService: e,
                        });

                        const groups = await api.get(`groups`);
                        // console.log(">>> groups", groups.data);
                        // setLstGroupInit(groups.data);

                        const arrayGroup = groups.data.map((i) =>
                          i.values
                            .split(",")
                            .map((x) => x.trim())
                            .includes(e.value)
                        );

                        const users = await api.get(
                          `users/?group=${groups.data[arrayGroup.lastIndexOf(true)].id}`
                        );

                        setLstAssignCallTo(
                          users.data.data.map((x) => {
                            return { label: x.name, value: x.uuid, group: x.id_group };
                          })
                        );
                        console.log(
                          ">>> users",
                          users.data.data.map((x) =>
                            console.log({ label: x.name, value: x.uuid, group: x.id_group })
                          )
                        );
                      }}
                    />
                  ) : (
                    <>
                      <VuiLabel title="Tipo de Manutenção" />
                      <VuiInput placeholder="Informe o Tipo de Manutenção" value={""} disabled />
                    </>
                  )}
                </div>
              </Grid>

              <Grid item xs={12} lg={12} xl={4}>
                <div style={{ width: isMobile ? "180%" : "100%" }}>
                  {!isDisabledInputs ? (
                    <VuiSelect
                      label="Atribuir Chamado Para?"
                      name="selectGender"
                      placeholder="Automatico..."
                      options={lstAssignCallTo}
                      defaultValue={null}
                      onCustomChange={async (e) => {
                        // console.log(">>> lstAssignCallTo:", e);
                        setStates({
                          ...states,
                          assignCallTo: e,
                        });
                      }}
                    />
                  ) : (
                    <>
                      <VuiLabel title="Atribuir Chamado Para?" />
                      <VuiInput placeholder="Selecione..." value={""} disabled />
                    </>
                  )}
                </div>
              </Grid>

              {/*  Line 6 */}
              <Grid item xs={12} lg={12} xl={12}>
                <VuiLabel title="Descrição do Problema:" />
                <TextArea
                  disabled={isDisabledText}
                  rows={8}
                  multiline
                  name="problemDescription"
                  value={states.problemDescription}
                  onChange={(e) => {
                    setStates({
                      ...states,
                      problemDescription: e.target.value,
                    });
                  }}
                  placeholder={
                    typeServiceSelect
                      ? typeServiceSelect.placeholder
                      : "Descreva aqui com todos os detalhes do problema"
                  }
                />
              </Grid>

              {/*  */}
              <Grid item xs={12} lg={12} xl={12} />
              <Grid item xs={12} lg={12} xl={12} />
              <Grid item xs={12} lg={12} xl={12} />
              <Grid item xs={12} lg={12} xl={8} />
              <Grid item xs={12} lg={12} xl={2}>
                <VuiButtonCustom
                  title={"Fechar"}
                  color="dark"
                  fontWeight="bold"
                  // disabled={!isDisabledSave}
                  onClick={() => {
                    onClose(true);
                  }}
                />
              </Grid>
              <Grid item xs={12} lg={12} xl={2}>
                <VuiButtonCustom
                  title="Abrir o Chamado"
                  color="success"
                  fontWeight="bold"
                  disabled={!isDisabledSave}
                  onClick={() => {
                    setIsSuccessRegister(true);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Content>
      <Footer />
    </>
  );
}

function ServiceOrder() {
  const { height, width } = useWindowDimensions();
  const [loading, setLoading] = useState(true);
  const [onClose, setOnClose] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);

  const history = useHistory();

  useEffect(() => {
    // A function that sets the display state for the DefaultNavbarMobile.
    function displayMobileNavbar() {
      if (window.innerWidth < breakpoints.values.lg) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    }

    /** 
     The event listener that's calling the displayMobileNavbar function when 
     resizing the window.
    */
    window.addEventListener("resize", displayMobileNavbar);

    // Call the displayMobileNavbar function to set the state with the initial value.
    displayMobileNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", displayMobileNavbar);
  }, []);

  useEffect(() => {
    // console.log(">>> actionCommand:", actionCommand);
    // console.log(">>>    actionExec:", actionExec.split("&"));
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, [false]);

  useEffect(() => {
    if (onClose) {
      localStorage.clear();
      history.push("/login?redirect=/supports");
    }
  }, [onClose]);

  if (loading) {
    return (
      <Container>
        <Content>
          <LoadingServiceOrder />
        </Content>
        <Footer />
      </Container>
    );
  }

  return (
    <Container>
      <Toaster position="top-right" reverseOrder={false} />
      <FormServiceOrder
        isMobile={isMobileView}
        onClose={() => {
          setOnClose(true);
        }}
      />
    </Container>
  );
}

export default ServiceOrder;
